import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import {cartList} from '@/api/server/cart'
import { regionData, CodeToText } from 'element-china-area-data'
import commonMixin from '@/mixin/common'
import {orderSubmit} from '@/api/server/order';
import {addressDefault} from '@/api/server/address';
export default {
  name: 'OrderPage',
  mixins: [commonMixin],
  data () {
    return {
      message: null,
      options: regionData,
      valueArea: null,
      consignee: null,
      mobile: null,
      address: null,
      area: {
        province: null,
        city: null,
        region: null,
        province_code: null,
        city_code: null,
        region_code: null
      },
      list: [],
      total: [],
      address: null

    }
  },
  components: {
    'nav-component': NavComponent,
    'footer-component': FooterComponent
  },
  computed: {
  },
  methods: {
    getAddressDefault () {
      addressDefault().then( (res) => {
        if (res.code === 200 && res.data) {
          this.address = res.data.address
          this.mobile = res.data.tel
          this.consignee = res.data.name
        }
      })
    },
    onSubmitOrder () {
        let consignee = this.consignee
        let mobile = this.mobile
        let province = this.area.province
        let city = this.area.city
        let region = this.area.region
        let province_code = this.area.province_code
        let city_code = this.area.city_code
        let region_code = this.area.region_code
        let address = this.address
        let message = this.message
        if (!this.list || this.list.length < 1) {
            this.error('您的购物车还没有商品')
            return false
        }
        if (!consignee) {
            this.error('请正确填写收货人')
            return false
        }
        if (!this.isPhone(mobile)) {
            this.error('请正确填写手机号码')
            return false
        }
        // if (!province || !city || !region || !province_code || !city_code || !region_code) {
        //     this.error('请正确选择所在地区')
        //     return false
        // }
        if (!address) {
            this.error('请正确填写详细地址')
            return false
        }
        let query = {
          message: message,
          consignee: consignee,
          mobile: mobile,
          province: province,
          city: city,
          region: region,
          province_code: province_code,
          city_code: city_code,
          region_code: region_code,
          address: address
        }
        orderSubmit(query).then( (res) => {
          if (res.code === 200) {
            this.success('提交订单成功')
            if (res.data.order_sn) {
              if (this.total.productAmount && this.total.productAmount >= 500) {
                this.$router.push({name: 'payline', query:{order_sn: res.data.order_sn}})
              } else {
                this.$router.push({name: 'pay', query:{order_sn: res.data.order_sn}})
              }
              
            }
          } else {
            this.error(res.message)
          }
        })
    },
    handleChangeCity (value) {
        if (value[0] && value[1] && value[2]) {
            this.area.province = CodeToText[value[0]]
            this.area.city = CodeToText[value[1]]
            this.area.region = CodeToText[value[2]]
            this.area.province_code = value[0]
            this.area.city_code = value[1]
            this.area.region_code = value[2]
        }
    },
    _getList () {
        let query = {
        }
        cartList(query).then((data) => {
          this._resetCart(data)
        }).catch((e) => {
          console.log('err', e)
        })
    },
    _resetCart (data) {
        if (data.code === 200 && data.data) {
            this.list = data.data.list
            this.total = data.data.cartTotal
        } else {
            this.warning(data.message)
        }
    },
    reset () {
        this.list = []
        this.total = []
        this.message = null
        this.address = null
        this._getList()
        this.getAddressDefault()
    },
    handleRoute (route) {
        if (route.name === 'order') {
            this.reset()
        }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}